import { OptimizationStatus } from '@/shared/generated'
import { useOptimizationStatus } from '@/shared/hooks/data'

export function useOptimizationIsReadyForChange(
	optimizationGroupId?: string | null
) {
	const status = useOptimizationStatus(optimizationGroupId)

	return (
		status &&
		![
			OptimizationStatus.Updating,
			OptimizationStatus.Scheduled,
			OptimizationStatus.Locked,
		].includes(status)
	)
}
